import type { ContextProp } from "react-virtuoso";

import { StreamThinkingIndicator } from "./StreamThinkingIndicator";
import type { MessagesVirtuosoContext } from "./MessageRow";

const MessagesVirtuosoFooter = ({ context }: ContextProp<MessagesVirtuosoContext>) => (
  <div className="pb-3">
    <StreamThinkingIndicator isLoading={context.isLoading} chatStore={context.chatStore} />
  </div>
);

export default MessagesVirtuosoFooter;
